/* TIMELESS MOONLIGHT MELTS — "Cast the spell" scent randomiser.
   Pulls the melt catalogue from Shopify's public collection products.json
   (Liquid caps collection loops at 50; the range is 250+), shuffles it, and
   reveals N picks. Each pick can be locked, expanded to read about, or added
   to basket on its own; or the whole set goes in at once.
   Dependency-free on purpose: no app, no framework. */

(function () {
  'use strict';

  var FAMILY_PREFIX = 'family:';
  var TICK = 65, BASE = 460, STAGGER = 105;

  function shuffle(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return fmt ? fmt.replace(/\{\{\s*amount\s*\}\}/, v) : '£' + v;
  }

  function strip(html, limit) {
    if (!html) return '';
    var d = document.createElement('div');
    d.innerHTML = html;
    var t = (d.textContent || '').replace(/\s+/g, ' ').trim();
    if (limit && t.length > limit) t = t.slice(0, limit).replace(/\s+\S*$/, '') + '…';
    return t;
  }

  function familyOf(p) {
    var tags = p.tags || [];
    for (var i = 0; i < tags.length; i++) {
      var tag = String(tags[i]);
      if (tag.toLowerCase().indexOf(FAMILY_PREFIX) === 0) return tag.slice(FAMILY_PREFIX.length).trim();
    }
    return p.product_type || '';
  }

  function normalise(p) {
    var v = (p.variants || [])[0] || {};
    var img = (p.images || [])[0];
    return {
      handle: p.handle,
      title: p.title,
      url: '/products/' + p.handle,
      image: img ? img.src : null,
      price: v.price != null ? Math.round(parseFloat(v.price) * 100) : null,
      variantId: v.id,
      available: !!v.available,
      family: familyOf(p),
      blurb: strip(p.body_html, 260)
    };
  }

  function Roller(root) {
    this.root = root;
    this.collection = root.dataset.collection || 'all';
    this.count = parseInt(root.dataset.count, 10) || 10;
    this.fmt = root.dataset.moneyFormat || '£{{ amount }}';
    this.rollLabel = root.dataset.rollLabel || 'Cast the spell';

    this.slots = [].slice.call(root.querySelectorAll('[data-rp-slot]'));
    this.rollBtn = root.querySelector('[data-rp-roll]');
    this.resetBtn = root.querySelector('[data-rp-reset]');
    this.allBtn = root.querySelector('[data-rp-addall]');
    this.errEl = root.querySelector('[data-rp-error]');
    this.hintEl = root.querySelector('[data-rp-hint]');

    this.pool = null;
    this.current = [];
    this.locked = [];
    this.rolling = false;
    for (var i = 0; i < this.count; i++) this.locked.push(false);

    this.bind();

    if (root.dataset.autoRoll === 'true') {
      var self = this;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); self.roll(); } });
        }, { rootMargin: '150px' });
        io.observe(root);
      } else { this.roll(); }
    }
  }

  Roller.prototype.bind = function () {
    var self = this;
    if (this.rollBtn) this.rollBtn.addEventListener('click', function () { self.roll(); });
    if (this.resetBtn) this.resetBtn.addEventListener('click', function () { self.clearLocks(); });
    if (this.allBtn) this.allBtn.addEventListener('click', function () { self.addAll(); });

    this.slots.forEach(function (slot, i) {
      var lock = slot.querySelector('[data-rp-lock]');
      var more = slot.querySelector('[data-rp-more]');
      var add = slot.querySelector('[data-rp-add]');
      if (lock) lock.addEventListener('click', function (e) { e.preventDefault(); self.toggleLock(i); });
      if (more) more.addEventListener('click', function (e) { e.preventDefault(); self.toggleDetail(i); });
      if (add) add.addEventListener('click', function (e) { e.preventDefault(); self.addOne(i); });

      /* WHOLE CARD IS A LINK to the product page.

         Everything with its own job is excluded by the closest() test below:
         the padlock, Read more, Add to basket, and the title anchor — which
         still handles its own navigation, so middle-click and cmd-click keep
         opening a new tab there.

         Guards: no navigation while the card is mid-roll (there is nothing to
         go to yet), none on a modified click, and none if the visitor was
         selecting text rather than clicking. */
      slot.addEventListener('click', function (e) {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (e.target.closest('button, a, input, label, select, textarea')) return;
        if (slot.classList.contains('is-rolling')) return;

        var sel = window.getSelection && window.getSelection();
        if (sel && String(sel).length > 0) return;

        var p = self.current[i];
        if (!p || !p.url) return;
        window.location.href = p.url;
      });
    });
  };

  Roller.prototype.toggleLock = function (i) {
    if (!this.current[i]) return;
    this.locked[i] = !this.locked[i];
    this.slots[i].classList.toggle('is-locked', this.locked[i]);
    var l = this.slots[i].querySelector('[data-rp-lock]');
    if (l) {
      l.setAttribute('aria-pressed', String(this.locked[i]));
      l.setAttribute('aria-label', this.locked[i] ? 'Release this scent' : 'Keep this scent');
    }
    this.updateControls();
  };

  Roller.prototype.toggleDetail = function (i) {
    var slot = this.slots[i];
    if (!this.current[i]) return;
    var open = slot.classList.toggle('is-open');
    var btn = slot.querySelector('[data-rp-more]');
    if (btn) {
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Close' : 'Read more';
    }
  };

  Roller.prototype.clearLocks = function () {
    this.locked = this.locked.map(function () { return false; });
    this.slots.forEach(function (s) {
      s.classList.remove('is-locked');
      var l = s.querySelector('[data-rp-lock]');
      if (l) { l.setAttribute('aria-pressed', 'false'); l.setAttribute('aria-label', 'Keep this scent'); }
    });
    this.updateControls();
  };

  Roller.prototype.lockedCount = function () {
    return this.locked.filter(Boolean).length;
  };

  Roller.prototype.updateControls = function () {
    var n = this.lockedCount(), have = this.current.filter(Boolean).length;
    if (this.rollBtn) {
      var lab = this.rollBtn.querySelector('[data-rp-roll-label]');
      if (lab) lab.textContent = (n > 0 && n < this.count) ? 'Roll the other ' + (this.count - n) : this.rollLabel;
      this.rollBtn.disabled = this.rolling || n === this.count;
    }
    if (this.resetBtn) this.resetBtn.hidden = n === 0;
    if (this.allBtn) this.allBtn.hidden = have === 0;
    if (this.hintEl) {
      this.hintEl.textContent = n === this.count
        ? 'Every scent is held — release one to roll again.'
        : (this.hintEl.dataset.defaultText || '');
    }
  };

  Roller.prototype.fetchPool = function () {
    if (this.pool) return Promise.resolve(this.pool);
    var self = this, base = '/collections/' + encodeURIComponent(this.collection) + '/products.json', all = [];

    function page(n) {
      return fetch(base + '?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          var items = (d && d.products) || [];
          all = all.concat(items);
          if (items.length === 250 && n < 4) return page(n + 1);
          return all;
        });
    }

    return page(1).then(function (ps) {
      self.pool = ps.map(normalise).filter(function (p) { return p.available; });
      return self.pool;
    });
  };

  Roller.prototype.roll = function () {
    if (this.rolling) return;
    var self = this;
    this.rolling = true;
    this.updateControls();
    if (this.errEl) this.errEl.textContent = '';

    this.fetchPool().then(function (pool) {
      if (!pool.length) throw new Error('empty');
      var keep = {};
      self.locked.forEach(function (L, i) { if (L && self.current[i]) keep[self.current[i].handle] = true; });
      var cands = shuffle(pool.filter(function (p) { return !keep[p.handle]; })), c = 0, picks = [];
      for (var i = 0; i < self.count; i++) {
        picks.push(self.locked[i] && self.current[i] ? self.current[i] : cands[c++]);
      }
      return self.animate(picks, pool);
    }).catch(function (e) {
      if (self.errEl) {
        self.errEl.textContent = (e && e.message === 'empty')
          ? 'No melts in stock to choose from right now.'
          : 'The spell fizzled — please refresh and try again.';
      }
    }).then(function () {
      self.rolling = false;
      self.updateControls();
    });
  };

  Roller.prototype.animate = function (picks, pool) {
    var self = this, jobs = [];
    picks.forEach(function (p, i) {
      if (self.locked[i] && self.current[i]) return;
      if (!p) return;
      var slot = self.slots[i], nameEl = slot.querySelector('[data-rp-name]');
      slot.classList.add('is-rolling');
      slot.classList.remove('just-landed', 'is-open', 'is-added');
      jobs.push(new Promise(function (res) {
        var t = setInterval(function () {
          var d = pool[Math.floor(Math.random() * pool.length)];
          if (d && nameEl) nameEl.textContent = d.title;
        }, TICK);
        setTimeout(function () {
          clearInterval(t);
          self.current[i] = p;
          self.paint(i, p);
          slot.classList.remove('is-rolling');
          slot.classList.add('just-landed');
          res();
        }, BASE + i * STAGGER);
      }));
    });
    return Promise.all(jobs);
  };

  Roller.prototype.paint = function (i, p) {
    var slot = this.slots[i];
    var q = function (s) { return slot.querySelector(s); };
    var name = q('[data-rp-name]'), price = q('[data-rp-price]'), fam = q('[data-rp-family]');
    var media = q('[data-rp-media]'), blurb = q('[data-rp-blurb]');
    var lock = q('[data-rp-lock]'), more = q('[data-rp-more]'), add = q('[data-rp-add]');

    if (name) { name.textContent = p.title; if (name.tagName === 'A') name.href = p.url; }
    if (price) price.textContent = p.price != null ? money(p.price, this.fmt) : '';
    if (fam) { fam.textContent = p.family || ''; fam.hidden = !p.family; }
    if (blurb) blurb.textContent = p.blurb || 'A hand-poured soy wax melt from the Timeless Moonlight range.';
    if (media) {
      media.innerHTML = '';
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2');
        img.alt = p.title; img.loading = 'lazy';
        media.appendChild(img);
      }
    }
    if (lock) lock.hidden = false;
    if (more) { more.hidden = false; more.textContent = 'Read more'; more.setAttribute('aria-expanded', 'false'); }
    if (add) { add.hidden = false; add.disabled = false; add.textContent = 'Add to basket'; }

    /* Marks the card as holding a real product — the CSS uses it to show the
       pointer cursor, so an empty slot never looks clickable. */
    slot.classList.add('is-filled');
  };

  /* ---- basket ------------------------------------------------------------ */

  Roller.prototype.postCart = function (items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Could not add to basket'); });
      return r.json();
    });
  };

  /* Milano owns the cart drawer. Rather than guess at its internals, refresh
     the visible counters and fire the events themes commonly listen for. */
  Roller.prototype.refreshCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sels = '[data-cart-count], .cart-count, .cart-count-bubble span, .header__cart-count, .minicart-count';
        document.querySelectorAll(sels).forEach(function (el) {
          if (el) el.textContent = cart.item_count;
        });
        ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (name) {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
        });
        return cart;
      })
      .catch(function () { /* counters are cosmetic — never block the add */ });
  };

  Roller.prototype.addOne = function (i) {
    var self = this, p = this.current[i];
    if (!p || !p.variantId) return;
    var btn = this.slots[i].querySelector('[data-rp-add]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    this.postCart([{ id: p.variantId, quantity: 1 }])
      .then(function () {
        self.slots[i].classList.add('is-added');
        if (btn) btn.textContent = 'In your basket';
        return self.refreshCart();
      })
      .catch(function (e) {
        if (btn) { btn.disabled = false; btn.textContent = 'Add to basket'; }
        if (self.errEl) self.errEl.textContent = e.message;
      });
  };

  Roller.prototype.addAll = function () {
    var self = this;
    var items = this.current.filter(Boolean)
      .filter(function (p) { return p.variantId; })
      .map(function (p) { return { id: p.variantId, quantity: 1 }; });
    if (!items.length) return;

    var btn = this.allBtn, label = btn && btn.querySelector('[data-rp-addall-label]');
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Adding…';

    this.postCart(items)
      .then(function () {
        if (label) label.textContent = 'Added to basket';
        self.slots.forEach(function (s, i) { if (self.current[i]) s.classList.add('is-added'); });
        self.slots.forEach(function (s) {
          var a = s.querySelector('[data-rp-add]');
          if (a) { a.disabled = true; a.textContent = 'In your basket'; }
        });
        return self.refreshCart();
      })
      .then(function () {
        setTimeout(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = 'Add all to basket';
        }, 2600);
      })
      .catch(function (e) {
        if (btn) btn.disabled = false;
        if (label) label.textContent = 'Add all to basket';
        if (self.errEl) self.errEl.textContent = e.message;
      });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-random-picks]').forEach(function (el) {
      if (el.dataset.rpReady === 'true') return;
      el.dataset.rpReady = 'true';
      new Roller(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.TMMRandomPicks = Roller;
})();
